import settings from "@src/settings";

interface Props {
  windowW?: number | null;
  gridUnit?: number;
}
const getGridWidth: (props: Props) => number = ({ windowW=settings.contentWidth.md, gridUnit=settings.baseGrid.fontSize }) => {
  if(!windowW ){
    return Math.floor(settings.contentWidth.md / gridUnit) * gridUnit;
  }
  return Math.floor(windowW / gridUnit) * gridUnit;
}

export default getGridWidth;